import { useState } from 'react'
import { useLocation } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'

// antd
import { Button, Form, Modal, Select, message } from 'antd'
import { CANDIDATE_STATUS } from './candidate-status-tab-list'
import ReactQuill from 'react-quill'
import {
    candidateAddNote,
    candidateById,
    candidateEdit,
} from '../store/candidate.slice'
import AttachmentUploader from './attachment-uploader-note'
import { uploadResume, uploadResumeS3Url } from '../service/candidate.service'

import ConverToUserForm from './convert-user-form'
import { getJobApplicantListByStatus } from '../../jobApplications/store/jobApplicant.slice'

const StatusModal = ({
    open,
    onClose,
    onChange,
    selectedStatus,
    statusModal,
    isDetails = false,
    activeStatus,
    isDetailsApi,
}) => {
    const dispatch = useDispatch()
    const [noteInput, setNoteInput] = useState('')
    const { userProfile } = useSelector((state) => state.loginSlice)
    const [attachments, setAttachments] = useState([])
    const { candidateId, activeTab, jobId } = useSelector(
        (state) => state.candidateSlice
    )
    const { applicantSearch } = useSelector((state) => state.jobApplicantSlice)

    const { state } = useLocation()

    const handleSaveNoteWithAttachments = async (
        candidateId,
        fieldName = 'add'
    ) => {
        try {
            let uploadedLinks = null

            if (attachments.length) {
                const payload = {
                    data: attachments.map((f) => ({
                        filename: f.name,
                        contentType: f.type,
                    })),
                }

                const { data } = await uploadResume(payload)

                if (data.success) {
                    uploadedLinks = []

                    for (const file of attachments) {
                        const match = data.data.find(
                            (item) => item.filename === file.name
                        )
                        if (!match) {
                            console.error(
                                `No upload URL for file: ${file.name}`
                            )
                            continue
                        }

                        const response = await uploadResumeS3Url(
                            file,
                            match.uploadUrl,
                            match.publicLink,
                            match.name
                        )
                        if (response.ok) {
                            uploadedLinks.push({
                                title: file.name, // You can modify if needed
                                displayName: file.name,
                                category: 'document', // Or customize this per use-case
                                file: {
                                    fileName: file.name,
                                    fileLink: match.publicLink,
                                    fileType: file.type,
                                    uploadDate: Date.now(),
                                },
                            })
                        } else {
                            console.error(
                                `Failed to upload ${file.name}:`,
                                await response.text()
                            )
                        }
                    }

                    // If no successful uploads, set attachments to null
                    if (uploadedLinks.length === 0) uploadedLinks = null
                }
            }

            // Finally call handleAddNote with S3 links (or null)
            await handleAddNote(candidateId, uploadedLinks, fieldName)
        } catch (error) {
            console.error('Error saving note with attachments:', error)
        }
    }

    const [form] = Form.useForm()
    const handleSubmit = async (status) => {
        if (status === 'convertToUser') {
            // Validate the form
            const values = await form.validateFields()
            let finalEmail = values.email
            if (!finalEmail.endsWith('@softwareco.com')) {
                finalEmail = `${finalEmail}@softwareco.com`
            }

            // Prepare the payload including email, password, timezoneLocation, etc.
            const payload = {
                status: status,
                candidateId: statusModal?.candidate?.candidateId,
                organisationEmail: finalEmail, // email from form
                password: values.confirmPassword, // password from form
                timeZone: values.timeZone, // timezoneLocation from form
                location: values.location,
            }
            // Make the API call to update the candidate
            const { data } = await candidateEdit(
                'STATUS',
                statusModal?.candidate?._id,
                payload
            )
            if (data.success) {
                if (!isDetailsApi) {
                    // If the request was successful, dispatch to fetch updated candidates
                    dispatch(
                        getJobApplicantListByStatus({
                            filter: {
                                status: activeTab,
                                job: jobId,
                                search: applicantSearch,
                            },
                        })
                    )
                } else {
                    if (candidateId) {
                        dispatch(
                            candidateById({
                                id: candidateId,
                                activeTab: 'OVERVIEW',
                            })
                        )
                    }
                }
            } else {
                // Handle error if the API response is unsuccessful
                console.error('Error updating candidate status:', data.message)
            }
        } else {
            try {
                const payload = {
                    status: status,
                    candidateId:
                        state?.candidateId ||
                        statusModal?.candidate?.candidateId,
                    jobId: state?.jobId || statusModal?.candidate?.jobId,
                }
                await candidateEdit(
                    'STATUS',
                    statusModal?.candidate?.candidateId,
                    payload
                )
                // if (data.success) {
                //     dispatch(getAllCandidate({
                //         filter: { status: activeStatus },
                //         skip: 0,
                //         limit: pagination?.limit,
                //     }))
                // }
                if (!isDetailsApi) {
                    // If the request was successful, dispatch to fetch updated candidates
                    dispatch(
                        getJobApplicantListByStatus({
                            filter: {
                                status: activeTab,
                                job: jobId,
                                search: applicantSearch,
                            },
                        })
                    )
                } else {
                    if (candidateId) {
                        dispatch(
                            candidateById({
                                id: candidateId,
                                activeTab: 'OVERVIEW',
                            })
                        )
                    }
                }
            } catch (error) {
                console.log('🚀 ~ handleSubmit ~ error:', error)
            }
        }
    }

    const handleAddNote = async (
        candidateId,
        attachments = null,
        fieldName = 'add'
    ) => {
        if (!noteInput.trim()) return

        try {
            const payload = {
                candidateComment: {
                    content: noteInput,
                    createdDate: Date.now(),
                    status: statusModal.status,
                    createdBy: userProfile._id,
                    attachments: attachments,
                },
                fieldName,
            }

            const { data } = await candidateAddNote(candidateId, payload)

            if (data.success) {
                setNoteInput('')
                // handleGetCandidateNotes(candidateId);
                setAttachments([])
            }
        } catch (error) {
            console.error('Error adding note:', error)
        }
    }
    const handleOnChange = (value) => {
        setNoteInput(value)
    }

    const handleCloseModel = () => {
        onClose()
        setNoteInput('')
    }

    return (
        <Modal
            open={open}
            title="Change Candidate Status"
            onCancel={() => handleCloseModel()}
            onOk={() => onClose()}
            footer={null}
        >
            <Select
                style={{ width: '100%' }}
                value={selectedStatus}
                // defaultValue={selectedStatus}
                onChange={(value) => {
                    onChange(value)
                    // onClose();
                }}
                placeholder="Select Status"
            >
                {CANDIDATE_STATUS.map((status) => (
                    <Select.Option key={status.value} value={status.value}>
                        {status.label}
                    </Select.Option>
                ))}
            </Select>
            <div style={{ marginTop: '15px' }}>
                {selectedStatus === 'convertToUser' && (
                    <ConverToUserForm form={form} />
                )}
                <ReactQuill
                    theme="snow"
                    className="status_note_editor"
                    style={{
                        backgroundColor: '#f8f8f8',
                        borderRadius: '12px',
                        border: 'none',
                        margin: '10px 0px',
                        height: '250px',
                    }}
                    onChange={handleOnChange}
                    value={noteInput}
                    placeholder={'Write a note...'}
                />
            </div>
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'end',
                    alignItems: 'center',
                    marginTop: '55px',
                }}
            >
                {/* <AttachmentUploader
                    attachments={attachments}
                    setAttachments={setAttachments}
                /> */}
                {selectedStatus === 'convertToUser' && isDetails === false && (
                    <div style={{ color: 'red' }}>
                        ⚠️ Please fill candidate education and experience before
                        converting to user.
                    </div>
                )}
                <Button
                    disabled={
                        selectedStatus === 'convertToUser' &&
                        isDetails === false
                    }
                    onClick={async () => {
                        try {
                            // Handle form submission and note saving with attachments
                            await handleSubmit(statusModal.status)
                            await handleSaveNoteWithAttachments(
                                statusModal.candidate._id
                            )
                            onClose()
                        } catch (error) {
                            if (error?.response?.data?.message) {
                                message.error(error?.response?.data?.message)
                            }
                        }
                    }}
                >
                    Submit
                </Button>
            </div>
        </Modal>
    )
}

export default StatusModal
